var render, staticRenderFns
import script from "./associated_terminals_two.vue?vue&type=script&lang=js"
export * from "./associated_terminals_two.vue?vue&type=script&lang=js"
import style0 from "./associated_terminals_two.vue?vue&type=style&index=0&id=35b1137f&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b1137f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35b1137f')) {
      api.createRecord('35b1137f', component.options)
    } else {
      api.reload('35b1137f', component.options)
    }
    
  }
}
component.options.__file = "found/views/mdm/views/user_management/form/associated_terminals/associated_terminals_two.vue"
export default component.exports